/**
 * Asynchronously loads the component for AttributeValue
 */

import { lazyLoad } from 'utils/loadable';

export const AttributeValue = lazyLoad(
  () => import('./index'),
  module => module.AttributeValue
);
